/* eslint-disable prefer-regex-literals */
import * as yup from 'yup';
// Utils
import isCorrectPhoneNumber from '../../src/utils/validations/phoneValidation';
import { isCorrectEmail } from '../../src/utils/validations/emailValidation';

const validation = yup.object().shape({
  firstName: yup.string().required('contact.form.error.required'),
  lastName: yup.string().required('contact.form.error.required'),
  phone: yup.string()
    .required('common.formErrors.required')
    .test('phone', 'common.formErrors.phone', (val) => isCorrectPhoneNumber({ phoneNumber: val, required: true })),
  email: yup.string().email('contact.form.error.email')
    .test('correctMail', 'contact.form.error.email', (val) => {
      if (val === undefined || val === null || val === '') return true;
      return isCorrectEmail(val);
    })
    .required('contact.form.error.required'),
  residence: yup.string(),
  request: yup.string(),
  comment: yup.string().required('contact.form.error.required'),
  newsletter: yup.boolean(),
});

export default validation;
